package com.nonopn.skywatcher.common.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChangePasswordRequest(
    val password: String,
    @SerialName("password_confirm")
    val passwordConfirm: String,
    @SerialName("password_old")
    val passwordOld: String,
)

@Serializable
data class ChangePasswordAnswer(
    val token: String,
)
